var Base = require('_js/base'),
  $ = require('jquery'),
  ko = require('knockout'),
  APIHelper = require('_js/APIHelper');

function EmployersModel(params) {
  var self = this;
  this.params = params;
  this.employers = ko.observableArray(this.params.employers);
  this.API = this.params.api;
  this.indexedEmployers = this.indexEmployers();

  this.current = ko.observable(-1);
  this.currentEmployerName = ko.observable('');
  this.currentEmployer = ko.computed(function() {
    return this.indexedEmployers[this.current()];
  }, this);

  this.chooseCompany = function(index) {
    this.current(index());
  }.bind(this);

  this.selects = $('.form-select-wrapper-special').selectize({
    valueField: 'aktorId',
    labelField: 'companyName',
    options: this.employers(),
    onChange: function(val) {
      self.currentEmployerName(val);
    }
  });
  if (this.employers().length > 0) {
    this.current(this.employers()[0].aktorId);
    // Set to first value.
    this.selects[0].selectize.setValue(this.employers()[0].aktorId);
  }

  this.activeModal = ko.observable(false);

  this.resultOption = ko.observable();
  this.results = ko.observableArray([]);
  this.isSearching = ko.observable(false);
  this.hasSearched = ko.observable(false);
  this.showSearchQuery = ko.observable(false);
  this.searchQuery = ko.observable().extend({
    required: [
      {
        type: 'isNumber',
        message: 'Her må du skrive inn organisasjonsnummer (9 siffer)'
      },
      { type: 'isLength', message: 'Feltet skal ha 9 siffer', length: 9 }
    ]
  });

  this.toggleSearchQuery = function() {
    self.showSearchQuery(!self.showSearchQuery());
  };
  this.searchOrganization = function() {
    if (self.searchQuery() === undefined) {
      return;
    }
    if (self.searchQuery.hasError()) {
      return;
    }
    self.isSearching(true);

    var url = this.API.addAgencyConnectionUrl;
    var data = { OrgNo: this.searchQuery() };
    APIHelper.post(
      url,
      data,
      function(data) {
        // data = tmpData;
        self.results(data);
        self.hasSearched(true);
        self.isSearching(false);
        // If we only got one result
        if (data.CreatedAgency !== null) {
          self.addEmployer(data.CreatedAgency);
        }
      },
      function(response) {
        self.hasSearched(true);
        self.isSearching(false);

        var location = window.location.href || document.URL;
        APIHelper.post('/api/log/error', {
          message: 'API-error: employee-list.js',
          context: location,
          parameters: [
            'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
            'platform: ' + navigator.platform,
            'responseText: ' + response.responseText,
            'status: ' + response.status,
            'statusText: ' + response.statusText,
            'requestUrl: ' + url
          ]
        });
      }
    );
  };
  this.addChosenEmployer = function() {
    var chosenEmployer = self.results().AvailableAgencies[self.resultOption()];
    var url = self.API.addAgencyConnectionUrl;
    var data = { OrgNo: self.searchQuery(), AktorId: chosenEmployer.AktorId };
    APIHelper.post(
      url,
      data,
      function() {
        self.addEmployer(chosenEmployer);
      },
      function(response) {
        var location = window.location.href || document.URL;
        APIHelper.post('/api/log/error', {
          message: 'API-error: employee-list.js',
          context: location,
          parameters: [
            'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
            'platform: ' + navigator.platform,
            'responseText: ' + response.responseText,
            'status: ' + response.status,
            'statusText: ' + response.statusText,
            'requestUrl: ' + url
          ]
        });
      }
    );
  };
}

EmployersModel.prototype.closeModal = function() {
  this.activeModal(false);
};

EmployersModel.prototype._getIndexOfCurrentEmployer = function() {
  var index = -1;
  for (var i = 0; i < this.employers().length; i++) {
    if (this.employers()[i].aktorId === this.currentEmployerName()) {
      index = i;
    }
  }
  return index;
};

EmployersModel.prototype.verifyRemoveEmployer = function() {
  this.activeModal(false);
  var self = this;
  var index = this._getIndexOfCurrentEmployer();
  if (index !== -1) {
    var url =
      this.API.endAgencyConnectionUrl +
      '?agencyAktorId=' +
      this.employers()[index].aktorId;
    APIHelper.post(
      url,
      {},
      function() {
        self.employers().splice(index, 1);
        self.indexedEmployers = self.indexEmployers();
        if (self.employers().length > 0) {
          self.current(self.employers()[0].aktorId);
        } else {
          self.current(-1);
        }
        self.selects[0].selectize.removeOption(self.currentEmployerName());
        self.selects[0].selectize.refreshItems();
      },
      function(err) {
        var location = window.location.href || document.URL;
        APIHelper.post('/api/log/error', {
          message: 'API-error: employee-list.js',
          context: location,
          parameters: [
            'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
            'platform: ' + navigator.platform,
            'responseText: ' + err.responseText,
            'status: ' + err.status,
            'statusText: ' + err.statusText,
            'requestUrl: ' + url
          ]
        });
      }
    );
  }
};

EmployersModel.prototype.addEmployer = function(employer) {
  // Need to map some of the properties to what is used when displaying data.
  employer.companyName = employer.Name;
  employer.orgNr = employer.OrgNo;
  employer.address = employer.StreetAddress;
  employer.postalCode = employer.StreetPostCode;
  employer.place = employer.StreetCity;
  employer.aktorId = employer.AktorId;

  this.employers().push(employer);
  this.employers.valueHasMutated();
  this.indexedEmployers = this.indexEmployers();
  this.selects[0].selectize.addOption(employer);
  this.selects[0].selectize.setValue(employer.aktorId);
  this.selects[0].selectize.refreshItems();

  // Reset search.
  this.searchQuery('');
  this.searchQuery.hasError(undefined);
  this.results([]);
  this.hasSearched(false);
  this.toggleSearchQuery();
};

EmployersModel.prototype.removeEmployer = function() {
  this.activeModal(true);
};

EmployersModel.prototype.indexEmployers = function() {
  var tmpEmployer = {};
  this.employers().forEach(function(employer) {
    tmpEmployer[employer.aktorId] = employer;
  });
  return tmpEmployer;
};

function ProfileEmployer() {
  this.init();
}

ProfileEmployer.prototype = new Base();

ProfileEmployer.prototype.init = function() {
  $('[data-employers]').each(function() {
    ko.applyBindings(new EmployersModel($(this).data('employers')), this);
  });
};

module.exports = ProfileEmployer;
